import { AxiosResponse } from 'axios';
import { subscribeComponentToErrorCode } from '@ferreri/minato-error-handler-react';

import client from '../../lib/service/plan.service';
import {
  Plan,
  PlanResponse,
  PlansResponse,
  PlanSetupResponse,
  PlanSetup,
  ListPlansResponse,
  BusinessUnit,
  BusinessUnitsResponse,
  PlanVersionsResponse,
  PlanVersion,
} from './plan.types';
import { PlanVersionNotFoundError } from './PlanVersionNotFoundError';

const PLAN_VERSION = `v1/plan_versions`;
const PLAN_SETUP = 'v1/plans';
const BUSINESS_UNITS = 'v1/business_units';
const PLAN = (slug) => `/${PLAN_VERSION}/${slug}`;
const PLAN_SETUP_ID = (id: string) => `${PLAN_SETUP}/${id}`;
const PLAN_DISTRIBUTIONS = 'v1/plan_distributions';
const PLAN_VERSIONS = (plan_distribution_id: string, status?: string) =>
  `${PLAN_DISTRIBUTIONS}/${plan_distribution_id}/plan_versions${
    status ? `?status=${status}` : ''
  }`;

export const getBusinessUnits = async (): Promise<BusinessUnit[]> => {
  const response = await client.get<BusinessUnitsResponse>(BUSINESS_UNITS);

  return response.data.business_units;
};

export const getPlanVersions = async (state?: string): Promise<Plan[]> => {
  const response = await client.get<string, AxiosResponse<PlansResponse>>(
    PLAN_VERSION,
    {
      params: {
        state,
      },
    },
  );
  return response.data.plan_versions;
};

export const getPlanVersion = async (slug: string): Promise<Plan> => {
  const response = await client.get<string, AxiosResponse<PlanResponse>>(
    PLAN(slug),
  );
  return response.data.plan_version;
};

export const getPlans = async (): Promise<PlanSetup[]> => {
  const response = await client.get<ListPlansResponse>(PLAN_SETUP);

  return response.data.plans;
};

export const getPlan = async (id: string): Promise<PlanSetup> => {
  const response = await client.get<string, AxiosResponse<PlanSetupResponse>>(
    PLAN_SETUP_ID(id),
  );
  return response.data.plan;
};

export const createPlan = async (plan: PlanSetup): Promise<PlanSetup> => {
  const response = await client.post<
    PlanSetup,
    AxiosResponse<PlanSetupResponse>
  >(PLAN_SETUP, { plan });

  return response.data.plan;
};

export const updatePlan = async (plan: PlanSetup): Promise<PlanSetup> => {
  const response = await client.put<
    PlanSetup,
    AxiosResponse<PlanSetupResponse>
  >(PLAN_SETUP_ID(plan.id), { plan });

  return response.data.plan;
};

export const getDistributionPlanVersions = async (
  plan_distribution_id: string,
  status: string,
): Promise<PlanVersion[]> => {
  const response = await client.get<PlanVersionsResponse>(
    PLAN_VERSIONS(plan_distribution_id, status),
  );

  return response.data.plan_versions;
};

subscribeComponentToErrorCode(
  'PlanVersionNotFoundError',
  PlanVersionNotFoundError,
);
